import { reloadPage } from "~lib/browserNavigation.ts";

const SKIP_WAITING_TIMEOUT_MS = 3000;
const RELOAD_DEADLINE_MS = 5000;

// A plain reload is answered from the service worker's precache, so an installed new build has to take over first
export async function reloadWithFreshShell(): Promise<void> {
  try {
    await Promise.race([activateWaitingWorker(), delay(RELOAD_DEADLINE_MS)]);
  } catch {
    // Reloading the stale shell still beats leaving the user on a dead page
  }

  reloadPage();
}

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function activateWaitingWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;

  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration) return;

  // An update check that fails offline must not stop the reload
  await registration.update().catch(() => {});

  const waiting = registration.waiting;
  if (!waiting) return;

  await new Promise<void>((resolve) => {
    const timeout = setTimeout(resolve, SKIP_WAITING_TIMEOUT_MS);

    navigator.serviceWorker.addEventListener(
      "controllerchange",
      () => {
        clearTimeout(timeout);
        resolve();
      },
      { once: true },
    );

    waiting.postMessage({ type: "SKIP_WAITING" });
  });
}
